  // Product page variant option selection
  var VariantSelect = (function() {
    
    var $variantSelection;
    
    // The selection filters from top to bottom. Only the 2nd and 3rd option 
    // variants can become unavailable
    function setUnavailable(index) {
      var option1 = $variantSelection.find('.active[data-index="0"]').data('option1');
      
      if(index===0) {
        // we need to set the unavailable items in indexes 1 & 2 (remember it's 0 index)
        $variantSelection.find('span[data-index="1"]:not([data-option1="'+option1+'"]), span[data-index="2"]:not([data-option1="'+option1+'"])').addClass('unavailable').removeClass('active');
        $variantSelection.find('span[data-index="1"][data-option1="'+option1+'"], span[data-index="2"][data-option1="'+option1+'"]').removeClass('unavailable');
        
      }
      
      else if(index===1) {
        // we need to set the unavailable items in index 2
        var option2 = $variantSelection.find('.active[data-index="1"]').data('option2');
        $variantSelection.find('span[data-index="2"]:not([data-option1="'+option1+'"][data-option2="'+option2+'"])').addClass('unavailable').removeClass('active');
        $variantSelection.find('span[data-index="2"][data-option1="'+option1+'"][data-option2="'+option2+'"]').removeClass('unavailable');
      }
    }
    
    // make sure we still have an active option in each section and that all options 
    // are showing that should be
    function setActive() {
      $variantSelection.each(function() {
        if(!$(this).find('span.active').length) $(this).find('span:not(.unavailable):first').addClass('active');
          
        // make sure the active item is showing
        if(!$(this).find('span.active:visible').length) {
          var $activeItem = $(this).find('span.active');
          var activeValue = $activeItem.data('val');
          $(this).find('span[data-val="'+activeValue+'"]:visible').hide().after($activeItem);
          $activeItem.show();
        }
        
        // make sure items that are not unavailable which have same name variants that
        // are unavailable are swapped out
        $(this).find('span.unavailable:visible').each(function() {
          var itemText = $(this).data('val');
          var $validItem = $(this).siblings('span[data-val="'+itemText+'"]:not(.unavailable):first');

          if($validItem.length) {
            $(this).hide().after($validItem);
            $validItem.show();
          }
        });
      });
    }
    
    function getActive() {
      if($variantSelection.find('span.active[data-index="2"]').length) return $variantSelection.find('span.active[data-index="2"]');
      if($variantSelection.find('span.active[data-index="1"]').length) return $variantSelection.find('span.active[data-index="1"]');
      if($variantSelection.find('span.active[data-index="0"]').length) return $variantSelection.find('span.active[data-index="0"]');
    }
    
    // the last index will always hold the correct id
    function setVariant() {
      var $active = getActive();

      $('[name="id"]').val($active.data('id'));
      $('#ProductPrice').html($active.data('price'))
    }
    
    function selectItem() {
      if($(this).hasClass('unavailable')) return;
      
      $(this).toggleClass('active').siblings('span').removeClass('active');
      var index = $(this).data('index');
      
      setUnavailable(index);
      setActive();
    }
    
    function init() {
      if(!$('.variant-selection').length) return;
      
      $variantSelection = $('.variant-selection');
      
      $variantSelection.find('span').click(selectItem);
      
      setActive();
      setVariant();
    }
    
    return function() {
      $(init);
    };
    
  })();
  
  // initialise it
  VariantSelect();